var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-sortable",
    { attrs: { tag: "w-list", items: _vm.settings, "target-class": "handle" } },
    [
      _vm._l(_vm.settings, function (item, i) {
        return _c(
          "w-list-item",
          { key: i, attrs: { "show-handle": "" } },
          [
            _c("w-list-item-text", [_vm._v(_vm._s(_vm.getText(item)))]),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("common.edit"),
                        expression: "$ct('common.edit')",
                      },
                    ],
                    attrs: { disabled: _vm.disabled },
                    on: {
                      click: function ($event) {
                        return _vm.editItem(i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "pen" } })],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-list-item-action",
              [
                _c(
                  "w-button",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.$ct("common.delete"),
                        expression: "$ct('common.delete')",
                      },
                    ],
                    staticClass: "danger",
                    attrs: { disabled: _vm.disabled },
                    on: {
                      click: function ($event) {
                        return _vm.removeItem(i)
                      },
                    },
                  },
                  [_c("w-fa", { attrs: { icon: "trash" } })],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _c(
        "w-list-item",
        {
          attrs: { disabled: _vm.disabled },
          on: {
            click: function ($event) {
              return _vm.addItem()
            },
          },
        },
        [
          _c("w-list-item-icon", [_c("w-fa", { attrs: { icon: "plus" } })], 1),
          _c("w-list-item-text", [
            _vm._v(_vm._s(_vm.$ct("add-text-if-value-item"))),
          ]),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toEditItem != null } },
        [
          _vm.toEditItem
            ? _c("app-text-if-value-edit", {
                attrs: {
                  "is-new": _vm.toEditIndex == -1,
                  model: _vm.model,
                  value: _vm.toEditItem,
                },
                on: {
                  close: function ($event) {
                    return _vm.closeEditor()
                  },
                  input: function ($event) {
                    return _vm.onInput($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }